<template>
    <section class="cusInfoList">
        <section class="card_list">
            <div class="card">
                <div class="head">
                    <h3>基本信息</h3>
                </div>
                <div class="item">
                    <div class="label"><p>姓名</p></div>
                    <div class="info"><p>{{cus.baseInfo.name}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>性别</p></div>
                    <div class="info">
                        <p v-if="cus.baseInfo.gender == 1">男</p>
                        <p v-else-if="cus.baseInfo.gender == 2">女</p>
                        <p v-else>未知</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>年龄</p></div>
                    <div class="info"><p>{{cus.baseInfo.age}}周岁</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>手机号</p></div>
                    <div class="info">
                        <p>
                            <a :href="'tel:' + cus.baseInfo.phoneNumber">
                                <span>{{cus.baseInfo.phoneNumber}}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                    <g clip-path="url(#clip0_376_2399)">
                                        <mask id="mask0_376_2399" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="22">
                                        <path d="M22 0H0V22H22V0Z" fill="white"/>
                                        </mask>
                                        <g mask="url(#mask0_376_2399)">
                                        <path d="M18.7798 16.7918L15.0535 13.4038C14.8774 13.2437 14.6459 13.1583 14.408 13.1657C14.1701 13.1731 13.9443 13.2725 13.7784 13.4432L11.5849 15.6991C11.0568 15.5983 9.99539 15.2674 8.90267 14.1775C7.80998 13.0839 7.4791 12.0196 7.38097 11.4953L9.63505 9.30079C9.80601 9.13498 9.90565 8.9092 9.91298 8.67122C9.92041 8.43325 9.83479 8.20175 9.67456 8.02572L6.28739 4.30038C6.12704 4.12378 5.90414 4.01667 5.66602 4.00179C5.42802 3.9869 5.19348 4.0654 5.01232 4.22062L3.02322 5.92654C2.86466 6.0856 2.77011 6.29729 2.75735 6.52147C2.74359 6.75063 2.48141 12.1791 6.69078 16.3903C10.363 20.0616 14.9627 20.3301 16.2296 20.3301C16.4147 20.3301 16.5284 20.3246 16.5587 20.3228C16.7828 20.3102 16.9943 20.2153 17.1526 20.056L18.8576 18.066C19.0136 17.8854 19.0927 17.6511 19.0781 17.413C19.0634 17.175 18.9564 16.952 18.7798 16.7918Z" fill="#0DDEF4"/>
                                        </g>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_376_2399">
                                        <rect width="22" height="22" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </a>
                        </p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>户籍城市</p></div>
                    <div class="info"><p>{{(cus.baseInfo.householdProvince || '未知') + '-' + (cus.baseInfo.householdCity || '未知')}}</p></div>
                </div>
            </div>                      
            <div class="card">
                <div class="head">
                    <h3>贷款信息</h3>
                </div>
                <div class="item">
                    <div class="label"><p>申请时间</p></div>
                    <div class="info"><p>{{cus.loanInfo.applicationTime}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>贷款金额</p></div>
                    <div class="info"><p>{{cus.loanInfo.loanAmount | f_currency}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>贷款期限</p></div>
                    <div class="info"><p>{{cus.loanInfo.loanTerm}}个月</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>贷款目的</p></div>
                    <div class="info"><p>{{cus.loanInfo.loanPurpose | f_loanPurpose}}</p></div>
                </div>
                <!-- <div class="item">
                    <div class="label"><p>产品类型</p></div>
                    <div class="info"><p>{{cus.loanInfo.productType | f_productType}}</p></div>
                </div> -->
            </div>
            <div class="card">
                <div class="head">
                    <h3>工作信息</h3>
                </div>
                <div class="item">
                    <div class="label"><p>工作城市</p></div>
                    <div class="info"><p>{{cus.workInfo.workProvince + '-' + cus.workInfo.workCity}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>职业</p></div>
                    <div class="info"><p>{{cus.workInfo.occupation | f_occupation}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>月收入</p></div>
                    <div class="info"><p>{{cus.workInfo.monthlyIncome | f_currency}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>收入形式</p></div>
                    <div class="info"><p>{{cus.workInfo.incomeForm | f_incomeForm}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>社保</p></div>
                    <div class="info">
                        <p v-if="cus.workInfo.socialSecurityStatus == 0">无</p>
                        <p v-if="cus.workInfo.socialSecurityStatus == 1 && !cus.workInfo.socialSecurityDetails">有</p>
                        <p v-if="cus.workInfo.socialSecurityStatus == 1 && cus.workInfo.socialSecurityDetails == 1">连续缴纳6个月以下</p>
                        <p v-if="cus.workInfo.socialSecurityStatus == 1 && cus.workInfo.socialSecurityDetails == 2">连续缴纳6个月以上</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>公积金</p></div>
                    <div class="info">
                        <p v-if="cus.workInfo.accumulationFundStatus == 0">无</p>
                        <p v-if="cus.workInfo.accumulationFundStatus == 1 && !cus.workInfo.accumulationFundDetails">有</p>
                        <p v-if="cus.workInfo.accumulationFundStatus == 1 && cus.workInfo.accumulationFundDetails == 1">连续缴纳6个月以下</p>
                        <p v-if="cus.workInfo.accumulationFundStatus == 1 && cus.workInfo.accumulationFundDetails == 2">连续缴纳6个月以上</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>商业保单</p></div>
                    <div class="info">
                        <p v-if="cus.workInfo.commercialInsurance == 0">无</p>
                        <p v-if="cus.workInfo.commercialInsurance == 1">有</p>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="head">
                    <h3>车产信息</h3>
                </div>
                <div class="item">
                    <div class="label"><p>是否有车</p></div>
                    <div class="info">
                        <p v-if="cus.carInfo.vehicleOwnership == 0">无</p>
                        <p v-if="cus.carInfo.vehicleOwnership == 1">有</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>购买方式</p></div>
                    <div class="info">
                        <p v-if="cus.carInfo.vehiclePurchaseMethod == 1">全款</p>
                        <p v-if="cus.carInfo.vehiclePurchaseMethod == 2">分期</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>使用性质</p></div>
                    <div class="info">
                        <p v-if="cus.carInfo.vehicleUse == 1">非营运</p>
                        <p v-if="cus.carInfo.vehicleUse == 2">营运</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>车牌号</p></div>
                    <div class="info"><p>{{cus.carInfo.licensePlate || '未知'}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>公里数</p></div>
                    <div class="info"><p>{{cus.carInfo.mileage || '-'}}公里</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>车辆估值</p></div>
                    <div class="info">
                        <div class="info"><p>{{cus.carInfo.vehicleValuation | f_currency}}</p></div>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>当前状态</p></div>
                    <div class="info">
                        <p v-if="cus.carInfo.vehicleStatus == 1">未抵押</p>
                        <p v-else-if="cus.carInfo.vehicleStatus == 2">已抵押</p>
                        <p v-else>未知</p>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="head">
                    <h3>房产信息</h3>
                </div>
                <div class="item">
                    <div class="label"><p>是否有房</p></div>
                    <div class="info">
                        <p v-if="cus.houseInfo.realEstateOwnership == 0">无</p>
                        <p v-if="cus.houseInfo.realEstateOwnership == 1">有</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>购买方式</p></div>
                    <div class="info">
                        <p v-if="cus.houseInfo.realEstatePurchaseMethod == 1">全款</p>
                        <p v-if="cus.houseInfo.realEstatePurchaseMethod == 2">按揭</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>房产性质</p></div>
                    <div class="info">
                        <p v-if="cus.houseInfo.realEstateNature == 1">商品房</p>
                        <p v-if="cus.houseInfo.realEstateNature == 2">自建房</p>
                        <p v-if="cus.houseInfo.realEstateNature == 3">厂房</p>
                        <p v-if="cus.houseInfo.realEstateNature == 4">其他</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>建筑面积</p></div>
                    <div class="info"><p>{{cus.houseInfo.buildingArea || '-'}}㎡</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>房产估值</p></div>
                    <div class="info">
                        <div class="info"><p>{{cus.houseInfo.realEstateValuation | f_currency}}</p></div>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>当前状态</p></div>
                    <div class="info">
                        <p v-if="cus.houseInfo.realEstateStatus == 1">未抵押</p>
                        <p v-else-if="cus.houseInfo.realEstateStatus == 2">已抵押</p>
                        <p v-else>未知</p>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="head">
                    <h3>信用负债</h3>
                </div>
                <div class="item">
                    <div class="label"><p>花呗</p></div>
                    <div class="info">
                        <p v-if="cus.assetInfo.huabei == 0">无</p>
                        <p v-else-if="cus.assetInfo.huabei == 1">有</p>
                        <p v-else>未知</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>白条</p></div>
                    <div class="info">
                        <p v-if="cus.assetInfo.baitiao == 0">无</p>
                        <p v-else-if="cus.assetInfo.baitiao == 1">有</p>
                        <p v-else>未知</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>信用卡</p></div>
                    <div class="info">
                        <p v-if="cus.assetInfo.creditCardStatus == 0">无</p>
                        <p v-else-if="cus.assetInfo.creditCardStatus == 1">有</p>
                        <p v-else>未知</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>芝麻分</p></div>
                    <div class="info"><p>{{cus.assetInfo.sesameScore | f_sesameScore}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>征信逾期</p></div>
                    <div class="info"><p>{{cus.assetInfo.creditOverdue | f_creditOverdue}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>当前总负债</p></div>
                    <div class="info">
                        <p>{{cus.assetInfo.totalDebt | f_currency}}</p>
                    </div>
                </div>
            </div>                     
        </section>
	</section>
</template>

<script>
import customerServer from "api/customer";

export default {
    name: "cusInfoList",
    props: {id: Number},
    data() {
        return {
            cus: {},
		};
    },    
    created() {
        this.getInfo();
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},	
    methods: {
        getInfo() {
            customerServer.getCusDetails({id: this.id}).then((res) => {
                this.cus = res.data
            })
        },
    },
};
</script>

<style lang="scss">
	.cusInfoList {
        .card {
            margin-bottom: 22px;
            background-color: #FDFDFD;
            border-radius: 24px;

            .head {
                padding: 16px 30px;
                border-bottom: 1px solid #E9F0F8;

                h3 {
                    color: #303030;
                    font-size: 17px;
                    line-height: 22px;
                    font-weight: 500;
                }
            }

            .item {
                margin-left: 30px;
                padding: 16px 30px 16px 0;
                border-bottom: 1px solid #E9F0F8;
                display: flex;
                justify-content: space-between;

                .label p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #4D5B80;
                }

                .info {
                    max-width: 70%;
                }

                .info p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #000;

                    a {
                        color: inherit;
                        
                        display: flex;
                        align-items: center;

                        span {
                            margin-right: 6px;
                        }
                    }
                }
            }

            .item:last-child {
                border-bottom: 0;
            }
        }

        .button_area {
            position: fixed;
            bottom: 30px;
            width: 100%;
            padding: 0 28px;
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/components/CusInfoList.vue